import axios from "axios"

function submitScore({}, data) {
    return axios.post('/api/v1/nps-scores', data)
}

function getLastSubmission({}, data, urlParams) {
    return axios.get('/api/v1/nps-scores/last-submission', { params: urlParams })
}

export const npsService = {
    submitScore,
    getLastSubmission,
}
